<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="single-page archive-post"
    id="post-page"
  >
    <PageHeader />
    <FilteredPostsList
      taxonomy="category"
      postType="post"
      filters
      key="category"
    />
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
import FilteredPostsList from "@/components/blocks/FilteredPostsList";

export default {
  name: "archive-posts",
  components: {
    FilteredPostsList
  }
};
</script>
